// React
import React, { Component } from "react";

// Components
import { Dropdown } from '../../Components';

// Stores
import { CurrencyStore, ChartStore } from '../../Stores';

// Styles
import "./charts.css";

// Utils
import { GoogleAnalytics } from '../../Utils';


class ChartMenu extends Component {

/**********************************************************
 *  Constructor
 **********************************************************/

    constructor(props) {

        //console.log('ChartMenu.constructor()');

        super(props);

        this.state = {
            // Exchange
            exchange: ChartStore.getAllParameters().exchange,
            exchanges : {
                "Kraken" : ['BTC', 'CAD', 'ETH', 'EUR', 'GBP', 'USD', 'JPY'],
                "Poloniex" : ['BTC']
            },
            
            // Currency
            currency: ChartStore.getAllParameters().currency,
            currencies: {
                "BTC": {
                    "ticker": "BTC",
                    "name": "Bitcoin",
                    "exchanges": {
                        "Kraken": {
                            "USD": 0
                        }
                    }
                }
            },

            // QuoteCurrency
            quoteCurrency : ChartStore.getAllParameters().quoteCurrency,

            // Interval
            interval : "1H",
            intervals : {
                '1M' : 'minute',
                '1H' : 'hour',
                '1D' : 'day'
            },
            
            fav : 'icon-heart6 text-pink icon-button',

            chartType : 'Candlestick',
            overlays : {
                "EMA 20" : false,
                "EMA 50" : false,
                "Bollinger" : false
            }

        };

    }


    
/**********************************************************
 *  Component Lifecycle Functions
 **********************************************************/

    // Upon mounting, retrieve the list of currencies
    // and the last or default chart parameters and save to state
    componentDidMount() {

        //console.log('ChartMenu.componentDidMount()');

        CurrencyStore.getExchanges()
            .then( (exchanges) => {
                this.setState({
                    exchanges : exchanges
                });
            });

        // Chart Parameters
        var params = ChartStore.getAllParameters();
        var trueInterval = Object.keys(this.state.intervals).find(key => this.state.intervals[key] === params.interval);

        // Currencies
        this.getCurrencies()
            .then( (response) => {

                this.setState((prev, props) => {
                    return {
                        currencies : response,
                        currency : params.currency,
                        exchange : params.exchange,
                        quoteCurrency : params.quoteCurrency,
                        interval : trueInterval
                    }
                });
            })
            .catch( (error) => {
                console.log('Error...');
                
                this.setState((prev, props) => {
                    return {
                        currency : params.currency,
                        exchange : params.exchange,
                        quoteCurrency : params.quoteCurrency,
                        interval : trueInterval
                    }
                });
            });
        
    }
    
 
/**********************************************************
 *  Chart Parameter Functions
 **********************************************************/

    // Given a ticker, determine other parameters and send
    // to parent Charts
    selectCurrency(ticker) {
        
        if(ticker !== this.state.currency) {

            // Log event to GA
            GoogleAnalytics.newAction('Chart', 'Currency', ticker);

            var newParameters = {
                currency : ticker,
                exchange : this.state.exchange,
                quoteCurrency : this.state.quoteCurrency,
                interval : this.state.intervals[this.state.interval]
            };

            // Check if current quote currency pairs with this currency
            var quoteCurrencyValid = this.state.currencies[ticker].exchanges[this.state.exchange].hasOwnProperty(this.state.quoteCurrency); 

            // Quote currency doesn't exist, so use the first one in the chain
            if(!quoteCurrencyValid) {
                newParameters.quoteCurrency = Object.keys(this.state.currencies[ticker].exchanges[this.state.exchange])[0];
            }

            // Pass new parameters up to parent chart
            this.props.onSelectParameters(newParameters);

            // Set state with new parameters
            this.setState((prev, props) => {
                return {
                    currency : newParameters.currency,
                    quoteCurrency : newParameters.quoteCurrency,
                    exchange : newParameters.exchange,
                    interval : this.state.interval
                }
            });

        }
    
    }


    // Given an exchange, determine other parameters and send
    // to parent Charts
    selectExchange(exchange) {
        
        if(exchange !== this.state.exchange) {

            // Log event to GA
            GoogleAnalytics.newAction('Chart', 'Exchange', exchange);

            var newParameters = {
                currency : this.state.currency,
                exchange : exchange,
                quoteCurrency : this.state.quoteCurrency,
                interval : this.state.intervals[this.state.interval]
            };
            
            // Check if exchange has current ticker and quoteCurrency available, otherwise default to first in each list
            var exchangeIsValid = this.state.currencies[this.state.currency].exchanges.hasOwnProperty(exchange);

            // Currency does not work with exchange, default to BTC
            // and select first quote currency
            if(!exchangeIsValid) {
                newParameters.currency = 'BTC'; // default to bitcoin
                newParameters.quoteCurrency = Object.keys(this.state.currencies['BTC'].exchanges[exchange])[0];
            }
            // Currency matches with exchange, check if quote currency is valid
            else {
                // check quote currency matching
                
                var quoteCurrencyValid = this.state.currencies[this.state.currency].exchanges[exchange].hasOwnProperty(this.state.quoteCurrency);

                if(!quoteCurrencyValid) {
                    newParameters.quoteCurrency = Object.keys(this.state.currencies[this.state.currency].exchanges[exchange])[0];
                }
            }

            // Pass new parameters up to parent chart
            this.props.onSelectParameters(newParameters);
            
            // Set state with new parameters
            this.setState((prev, props) => {
                return {
                    currency : newParameters.currency,
                    quoteCurrency : newParameters.quoteCurrency,
                    exchange : newParameters.exchange
                }
            });
                
        }
    }


    // Given a valid quotecurrency, send to parent chart
    selectQuoteCurrency(quoteCurrency) {
        
        if(quoteCurrency !== this.state.quoteCurrency) {

            // Log event to GA
            GoogleAnalytics.newAction('Chart', 'QuoteCurrency', quoteCurrency);

            var newParameters = {
                currency : this.state.currency,
                exchange : this.state.exchange,
                quoteCurrency : quoteCurrency,
                interval : this.state.intervals[this.state.interval]
            };

            // Pass new parameters up to parent chart
            this.props.onSelectParameters(newParameters);
            
            // Set state with new parameters
            this.setState((prev, props) => {
                return {
                    currency : newParameters.currency,
                    quoteCurrency : newParameters.quoteCurrency,
                    exchange : newParameters.exchange
                }
            });
        }

    }


    // Given an interval, send to parent chart
    selectInterval(interval) {
        
        if(interval !== this.state.interval) {

            // Log event to GA
            GoogleAnalytics.newAction('Chart', 'Interval', interval);

            var newParameters = {
                currency : this.state.currency,
                exchange : this.state.exchange,
                quoteCurrency : this.state.quoteCurrency,
                interval : this.state.intervals[interval]
            };

            // Pass new parameters up to parent chart
            this.props.onSelectParameters(newParameters);
            
            // Set state with new parameters
            this.setState((prev, props) => {
                return {
                    currency : newParameters.currency,
                    quoteCurrency : newParameters.quoteCurrency,
                    exchange : newParameters.exchange,
                    interval : interval
                }
            });
        }

    }

    // Choose between candlestick and heikin-ashii
    selectChartType(type) {

        this.props.onSelectChartType(type);

        // Set state with new parameters
        this.setState((prev, props) => {
            return {
                chartType : type
            }
        });

    }


    // Select an overlay and apply it to chart
    selectOverlay(overlay) {

        var status = !this.state.overlays[overlay];
        var ovs = this.state.overlays;

        ovs[overlay] = status;

        this.props.onSelectOverlay(overlay, status);

        this.setState((prev, props) => {
            return {
                overlays : ovs
            }
        });
    }
        

    // Favourite a chart selection
    favouriteChart() {

        //console.log('Charts.selectCandle()');

        // Log event to GA
        var chartCode = this.state.currency + '-' + this.state.exchange + 
        '-' + this.state.quoteCurrency + '-' + this.state.interval;

        GoogleAnalytics.newAction('Chart', 'Favourite', chartCode);

        var newClass = '';

        if(this.state.fav === 'icon-heart5 text-pink icon-button')
            newClass = 'icon-heart6 text-pink icon-button';
        else
            newClass = 'icon-heart5 text-pink icon-button';
        
        this.setState((prev, props) => {
            return {
                fav : newClass
            }
        });

    }


/**********************************************************
 *  Helper Functions
 **********************************************************/

    // Retrieve the list of currencies and return as promise
    getCurrencies() {
    
        //console.log('Charts.getCurrencies()');

        return new Promise( (resolve, reject) => {

            CurrencyStore.getCurrencies()
                .then( (response) => {

                    resolve(response);

                })
                .catch( (error) => {

                    reject(error);

                });

        });
        
    }

    // Given a currency object, determine if its valid
    // based on matching the currenctly selected exchange and
    // quotecurrency
    isCurrencyValid(currency) {
        
        var validExchange = false;
        var validQuoteCurrency = true;
    
        var _this = this;
        
        for(let key of Object.keys(currency.exchanges)) {
    
            if(key === _this.state.exchange) {
                validExchange = true;    
            }
        }
    
        return validExchange && validQuoteCurrency;
    }

    
/**********************************************************
 *  Render
 **********************************************************/

    render() {

        //console.log('ChartMenu.render()');

        var _this = this;

        // Overlays and Candlestick options
        var overlays = (
            <div className="flex-menu-row overlays" >

                <Dropdown icon='icon-stats-bars4' value={this.state.chartType}>
                    <li onClick={() => _this.selectChartType('Candlestick')}><a href={null}><i className="icon-stats-bars4"></i>Candlestick</a></li>
                    <li onClick={() => _this.selectChartType('Heikin-Ashi')}><a href={null}><i className="icon-stats-bars4"></i>Heikin-Ashi</a></li>
                </Dropdown>

                <Dropdown icon='icon-stats-dots' value={'Overlays'}>
                    {
                        Object.keys(_this.state.overlays).map(function(overlay) {
                            return (<li key={overlay} onClick={() => _this.selectOverlay(overlay)}><a href={null}>
                            <i className={_this.state.overlays[overlay] ? "red-text icon-minus3" : "green-text icon-plus3"}></i>{overlay}</a></li>)
                        })
                    }
                </Dropdown>
                
            </div>
        );

        // hide options on mobile
        if(this.props.mobile) {
            overlays = null
        }

        // Tidied arrays for dropdowns
        var tickers = Object.keys(this.state.currencies).sort();

        var quoteCurrencies = [];
        if(Object.keys(this.state.currencies).length > 1)
            quoteCurrencies = Object.keys(this.state.currencies[this.state.currency].exchanges[this.state.exchange]).sort();
        
        return (

            <div className="flex-menu">
            
            <div className="flex-menu-row" >
        
                    {/*----------- Currencies -----------*/} 
                    <div className="dropdown">
                        <a type="button" className="btn btn-link dropdown-toggle legitRipple left-b" 
                        data-toggle="dropdown" aria-expanded="true"> {this.state.currency}
                        <span className="caret"></span></a>
                        <ul className="dropdown-menu scroll">
                        {
                            tickers.map(ticker => {
                                if(_this.isCurrencyValid(_this.state.currencies[ticker])) {
                                    return (<li key={ticker} onClick={() => _this.selectCurrency(ticker)}><a href={null}>{ticker}</a></li>)
                                }
                                else
                                    return null
                            })
                        }
                        </ul>
                    </div>

                    
                    {/*----------- Exchanges -----------*/}
                    <Dropdown icon='icon-transmission' value={this.state.exchange}>
                        {
                            Object.keys(this.state.exchanges).map((ex, id) => <li key={id} onClick={() => _this.selectExchange(ex)}><a href={null}>{ex}</a></li>)
                        }
                    </Dropdown>

                    
                    {/*----------- Quote Currencies -----------*/}
                    <Dropdown icon='icon-coins' value={this.state.quoteCurrency}>
                        {
                            quoteCurrencies.map(ticker => {
                                return (
                                    <li key={ticker} onClick={() => _this.selectQuoteCurrency(ticker)}><a href={null}><div className='currency-symbol'>{CurrencyStore.getCurrencySymbol(ticker)}</div>{ticker}</a></li>
                                )
                            })
                        }
                    </Dropdown>

                            
                    {/*----------- Intervals -----------*/}
                    <Dropdown icon='icon-watch2' value={this.state.interval}>
                        {
                            Object.keys(_this.state.intervals).map(function(interval) {
                                return (<li key={interval} onClick={() => _this.selectInterval(interval)}><a href={null}>{interval}</a></li>)
                            })
                        }
                    </Dropdown>
                    

            </div>

            {overlays}
            
            {/*----------- End Dropdown Menu -----------*/}

            </div>
        );
    }
}

export default ChartMenu;




// WEBPACK FOOTER //
// ./src/Views/Charting/ChartMenu.js